import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/BlankLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/app/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClientLocalizationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotiStackProvider"] */ "/app/src/components/Notistack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeQueryClient","getQueryClient"] */ "/app/src/libs/react-query/get-query-client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/react-query/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/redux-store/ReduxProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/NotFound.tsx");
